import ApiUtils from './apiUtils.js';

export default class EventsApiUtils extends ApiUtils {
    constructor(url) {
        super(url, 'Events');
    }
}
